import { useLocation, useNavigate } from "react-router";
import { canGoBack } from "../../../shared/phone/history";
import type { PhoneBack } from "../../../shared/phone/PhoneNav";

/** What a row in More hands the screen it opens, so the screen knows More is behind it. */
export const FROM_MORE = { from: "/more" } as const;

/**
 * Back from a screen More opens: to More when it came from there or was opened afresh; when another
 * screen opened it, such as a goal's "Connect provider", back returns there.
 */
export function useParentBack(parent: PhoneBack): PhoneBack {
  const { state } = useLocation();
  const navigate = useNavigate();
  const fromParent = (state as { from?: string } | null)?.from === parent.to;
  if (fromParent || !canGoBack()) return parent;
  return { to: parent.to, onBack: () => navigate(-1) };
}
